import { appRouterPaths } from 'services/navigation';
import { RegionsPage } from 'pages/Regions';
import type { AppRouteProps } from '../types';

export const regionsPageRoute: AppRouteProps = {
  path: appRouterPaths.regions,
  element: <RegionsPage />,
};

// export const regionPageRoute: AppRouteProps = {
//   path: appRouterPaths.region,
//   element: <RegionPage/>,
// };
